import Spinner from '@modules/common/icons/spinner'
import React from 'react'

type Props = {
  fullScreen?: boolean
  active: boolean
}

function BHSpinner({ fullScreen = false, active }: Props) {
  return (
    <div
      className={`absolute z-50 ${fullScreen ? 'h-full w-full' : 'left-0 top-0 right-0 bottom-0'} transition-opacity duration-300 bg-bh-black ${
        active
          ? 'opacity-50 pointer-events-auto z-50'
          : 'opacity-0 pointer-events-none -z-10'
      }`}
    >
      <div className="absolute opacity-100 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
        <Spinner color="red" />
      </div>
    </div>
  )
}

export default BHSpinner
